import { useEffect, useState } from "react";
import { useTheme } from "../../../components/hooks/useTheme";

type Props = {
  data: {
    link: string | number | readonly string[] | undefined;
    id: number;
    roleName: string;
    roleDescription: string;
    isActive: boolean;

  };
  handleDelete: (id: number) => void;
  handleTheChange: (
    id: number,
    changedRoleName: string,
    roleDescription: string,
    isActive: boolean
  ) => void;
};

export const AddLabel = (props: Props) => {
  const { themeStyles } = useTheme();
  const [roleName, setRoleName] = useState(props.data.roleName);
  const [roleDescription, setRoleDescription] = useState(props.data.roleDescription);
  const [isActive, setIsActive] = useState(props.data.isActive);

  useEffect(() => {
    props.handleTheChange(props.data.id, roleName, roleDescription, isActive);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleName, roleDescription, isActive]);

  return (
    <div className="w-full flex flex-row justify-center items-center px-6 mb-2">
      <div className="w-1/2 mr-2">
        <input
          type="text"
          name="roleName"
          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
          value={roleName}
          onChange={(e) => setRoleName(e.target.value)}
          readOnly={roleName?.trim()?.toLocaleLowerCase() === "admin"}
          required
        />
      </div>

      <div className="w-1/2 mr-2">
        <input
          type="text"
          name="roleDescription"
          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
          value={roleDescription}
          onChange={(e) => setRoleDescription(e.target.value)}
          readOnly={roleName?.trim()?.toLocaleLowerCase() === "admin"}
          required
        />
      </div>

      <div className="w-[10%] mr-2">
        <select
          name="active"
          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
          value={isActive ? "Yes" : "No"}
          disabled={roleName?.trim()?.toLocaleLowerCase() === "admin"}
          onChange={(e) => setIsActive(e.target.value === "Yes")}
        >
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>

      <div className="w-[5%]">
        {
          roleName?.trim()?.toLocaleLowerCase() !== "admin" && (
            <span
              className={`material-symbols-outlined text-[25px] font-medium text-red-500 cursor-pointer`}
              onClick={() => props.handleDelete(props.data.id)}
            >
              delete
            </span>
          )
        }
      </div>
    </div>
  );
};
